import { useEffect, useState, useRef, type MutableRefObject } from 'react';

export interface MousePositionHook {
  x: number | null;
  y: number | null;
}

interface HeightAndWidth {
  height: number;
  width: number;
}

export default function useMousePosition(
  ref: MutableRefObject<HTMLElement> | null = null,
  offsetY = 10,
  offsetX = 35,
): MousePositionHook {
  const [mousePosition, setMousePosition] = useState<MousePositionHook>({
    x: null,
    y: null,
  });

  const heightAndWidth = useRef<HeightAndWidth>({ height: 0, width: 0 });

  useEffect(() => {
    if (ref?.current) {
      heightAndWidth.current.height = ref.current.offsetHeight;
      heightAndWidth.current.width = ref.current.offsetWidth;
    }
  }, [ref]);

  useEffect(() => {
    const updateMousePosition = ({ pageX, pageY }: MouseEvent) => {
      // This is used for positioning in the bottom right of the mouse. Useful for components
      // such as popovers but it's also optional
      setMousePosition({
        x: pageX - heightAndWidth.current.width / 4 + offsetX,
        y: pageY - heightAndWidth.current.height / 4 + offsetY,
      });
    };

    window.addEventListener('mousemove', updateMousePosition);
    return () => {
      window.removeEventListener('mousemove', updateMousePosition);
    };
  }, []);
  return mousePosition;
}
